<template>
  <div>
    <button class="d-none" data-toggle="modal" data-target="#TournamentAddGame" ref="openModalTournamentAddGame"
      @click="dataReset()"></button>
    <div class="modal fade" tabindex="-1" role="dialog" id="TournamentAddGame">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div>
              <h6 class="modal-title m-0">{{ isEditingGame ? 'Edit Game' : 'New Game' }}</h6>
              <!-- <p>Date: {{ date }}</p> -->
              <div class="products-list-shim p-0" v-if="showLoader == 1">
                <content-placeholders :rounded="true">
                  <content-placeholders-text :lines="1" />
                </content-placeholders>
              </div>
              <span v-else class="text-capitalize">{{tournamentData?.tournamentName}}</span>
            </div>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"
              ref="closeModalTournamentAddGame">
              <img src="../../assets/Svg/close.svg" />
            </button>
          </div>
          <div class="modal-body">
            <div class="row no-gutters">
              <div class="col-12 col-md-3 pr-md-2">
                <div class="form-group">
                  <select class="form-control" id="gameType" v-model="game_type" :class="{
                    filled: game_type,
                    'is-invalid': $v.game_type.$error,
                    'is-valid': !$v.game_type.$invalid,
                  }">
                    <option value="1">Pool</option>
                    <!-- <option value="2" disabled>Bracket</option> -->
                  </select>
                  <span v-if="!$v.game_type.required" class="invalid-tooltip">
                    Game type is required
                  </span>
                  <span class="placeholder">Game Type</span>
                </div>
              </div>

              <div class="col-12 col-md-9">
                <div class="form-group">
                  <input id="game-name" class="form-control" v-model="name" spellcheck="false"
                    autocomplete="off" trim type="text" required :class="{
                      filled: name,
                      'is-invalid': $v.name.$error,
                      'is-valid': !$v.name.$invalid,
                  }"/>
                   <span v-if="!$v.name.required" class="invalid-tooltip">
                    Game name is required
                  </span>
                  <span class="placeholder">Game Name</span>
                </div>
              </div>
            </div>

            <div class="row no-gutters">
               <div class="col-sm-12 col-md-6">
                <div class="form-group">
                  <select class="form-control" id="teamOne" v-model="teamOne"
                    @change="filterTeam" :disabled="teamLoader"
                    :class="{
                      filled: teamOne,
                        'is-invalid': shouldValidateTeams && $v.teamOne.$error,
                        'is-valid': shouldValidateTeams && !$v.teamOne.$invalid
                      }">
                    <option v-for="option in tournamentTeams"
                      :value="option.team.id" :key="option.id" >
                      #{{ option.team_sr_no }}: {{ option.team.team_name }}
                    </option>
                  </select>
                  <span class="placeholder">Team 1</span>
                  <div class="invalid-tooltip" v-if="shouldValidateTeams && !$v.teamOne.required">
                    Team 1 is required
                  </div>
                  <div class="shop-products-img-loader" v-if="teamLoader">
                    <div class="lds-dual-ring-media"></div>
                  </div>
                </div>
              </div>

              <div class="col-sm-12 col-md-6 pl-md-2">
                <div class="form-group">
                  <select class="form-control" id="teamTwo"
                    v-model="teamTwo" :disabled="teamLoader"
                    :class="{
                      filled: teamTwo,
                      'is-invalid': shouldValidateTeams && $v.teamTwo.$error,
                      'is-valid': shouldValidateTeams && !$v.teamTwo.$invalid
                    }">
                    <option
                      v-for="option in remainingTeams"
                      :value="option.team.id"
                      :key="option.id"
                    >
                     #{{ option.team_sr_no }}: {{ option.team.team_name }}
                    </option>
                  </select>
                  <span class="placeholder">Team 2</span>
                  <div class="invalid-tooltip" v-if="shouldValidateTeams && !$v.teamTwo.required">
                    Team 2 is required
                  </div>
                  <div class="shop-products-img-loader" v-if="teamLoader">
                    <div class="lds-dual-ring-media"></div>
                  </div>
                </div>
              </div>

              <div class="col-sm-12 col-md-6">
                <div class="form-group">
                  <select class="form-control" id="teamOne" :class="{ filled: umpire }" v-model="umpire"
                    :disabled="isLoadingUmpire">
                    <option v-for="option in tournamentUmpire" :value="option.umpire.id" :key="option.umpire.id">
                      {{ option.umpire.name }}
                    </option>
                  </select>
                  <span class="placeholder">Umpire</span>
                  <div class="shop-products-img-loader" v-if="isLoadingUmpire">
                    <div class="lds-dual-ring-media"></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row no-gutters">
              <div class="col-sm-12 col-md-6">
                <div class="form-group" :class="{ filled: startDate }">
                  <span class="event-error d-none" v-if="startDateError != ''">
                    Please Select Start Date.
                  </span>
                  <date-picker :open="open" @close="open = false" :editable="false" :clearable="false"
                    @click.native="open = true" :disabled="showLoader == 1" v-model="startDate" valueType="format"
                    format="MMM DD, YYYY" @change="checkdate" :class="{
                    'is-invalid': $v.startDate.$error,
                    'is-valid': !$v.startDate.$invalid,
                  }">
                    <i slot="icon-calendar" class="cursor-pointer" v-show="showLoader == 0">
                      <img src="../../assets/Svg/calendar.svg" />
                    </i>
                  </date-picker>
                  <span v-if="!$v.startDate.required" class="invalid-tooltip">
                    Start date is required
                  </span>
                  <span class="placeholder">Start Date</span>

                  <div class="shop-products-img-loader" v-if="showLoader == 1">
                    <div class="lds-dual-ring-media"></div>
                  </div>
                </div>
              </div>

              <div class="col-sm-12 col-md-6 pl-md-2">
                <div class="form-group" :class="{ filled: startTime }">
                  <span class="event-error" v-if="timeError != ''">
                    Event Time is Invalid.
                  </span>
                  <div class="input-group time" id="startTimeCheck" data-target-input="nearest">
                    <vue-timepicker id="startTime" class="time-input" format="hh:mm A" required="required"
                      v-model="startTime" v-on:change="checkTime" hide-clear-button @open="dropdownState = 'opened'"
                      @close="dropdownState = 'closed'" :class="{
                      'is-invalid': $v.startTime.$error,
                      'is-valid': !$v.startTime.$invalid,
                    }">
                      <template v-slot:icon>
                        <img src="../../assets/Svg/clock.svg" />
                      </template>
                    </vue-timepicker>
                    <span v-if="!$v.startTime.required" class="invalid-tooltip">
                      Start time is required
                    </span>
                  </div>
                  <span class="placeholder">Start Time</span>
                </div>
              </div>
            </div>

            <div class="row no-gutters mb-3">
              <div class="col-sm-12 col-md-6 my-3 my-md-0">
                <div class="position-relative">
                  <multiselect v-model="partName" id="ajaxsingle" label="park_name" track-by="id" placeholder="Park"
                    open-direction="top" :options="parkNameOptions" :searchable="true" :loading="isLoading"
                    :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="300"
                    :show-no-results="false" :hide-selected="true" @search-change="debouncedGetGamePark"
                    @input="checkParkField" @select="dispatchAction" :class="{
                    'is-invalid': $v.partName.$error,
                    'is-valid': !$v.partName.$invalid
                  }">
                    <template slot="tag" slot-scope="{ option, remove }">
                      <span class="custom__tag">
                        &nbsp;<span> {{ option.park_name }}</span>
                        <span class="custom__remove" v-on:click="remove(option)">❌</span>
                      </span>
                    </template>
                    <span slot="noResult">Oops! No Park found. Consider changing the search query.</span>
                    <span slot="noOptions"> No Park Found </span>
                    <template #caret>
                      <span class="custom-arrow">
                        <img src="../../assets/Svg/arrow-down.svg" alt="add" />
                      </span>
                    </template>
                    <template slot="option" slot-scope="{ option }">
                      <div class="option__desc">
                        <span> {{ option.park_name }}</span>
                      </div>
                    </template>
                  </multiselect>
                  <span v-if="!$v.partName.required" class="invalid-tooltip">
                    Park is required
                  </span>
                </div>
              </div>

              <div class="col-sm-12 col-md-6 pl-md-2">
                <div class="">
                  <multiselect v-model="parkField" id="ajaxsingle" label="field_name" track-by="id" placeholder="Field"
                    open-direction="top" :options="fieldNameOptions" :searchable="true" :loading="isLoadingField"
                    :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="300"
                    :show-no-results="false" :hide-selected="true" @search-change="getParkField" @input="checkParkField"
                    @select="dispatchfieldAction">
                    <template slot="tag" slot-scope="{ option, remove }">
                      <span class="custom__tag">
                        &nbsp;<span> {{ option.field_name }}</span>
                        <span class="custom__remove" v-on:click="remove(option)">❌</span>
                      </span>
                    </template>
                    <span slot="noResult">Oops! No Field found. Consider changing the search query.</span>
                    <span slot="noOptions"> No Field Found </span>
                    <template #caret>
                      <span class="custom-arrow">
                        <img src="../../assets/Svg/arrow-down.svg" alt="add" />
                      </span>
                    </template>
                    <template slot="option" slot-scope="{ option }">
                      <div class="option__desc">
                        <span> {{ option.field_name }}</span>
                      </div>
                    </template>
                  </multiselect>
                </div>
              </div>
            </div>

            <div class="form-group">
              <input type="text" class="form-control" id="note" v-model="note" required />
              <span class="placeholder">Game Notes</span>
            </div>

            <a class="d-none" data-toggle="modal" data-target="#ModalPARK" ref="callPark" @click="closeMain">
              Add New Park
            </a>
            <a class="d-none" data-toggle="modal" data-target="#ModalField" ref="callField" @click="newField">
              Add New Field
            </a>
          </div>

          <div class="event-btns-wrapper justify-content-end">
            <button type="button" class="btn btn-primary"
              @click="saveGame(0)" :disabled="isDisabled || isLoadingArray[0]">
              <div v-if="isLoadingArray[0]" class="lds-dual-ring"></div>
              <div v-else>
                <img class="mr-1" src="../../assets/Svg/save.svg" alt="save" />Save
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
    <NewPark />
    <NewField />
  </div>
</template>
<script>
import axios from "axios";
import VueTimepicker from "vue2-timepicker";
import Multiselect from "vue-multiselect";
import NewPark from "../Teams/Games/AddPark.vue";
import NewField from "../Teams/Games/AddField";
import {
  required,
} from "vuelidate/lib/validators";
export default {
  name: "PoolPlayAddGameModal",
  components: {
    VueTimepicker,
    Multiselect,
    NewPark,
    NewField,
  },
  data() {
    return {
      dropdownState: 'closed',
      name: "",
      teamOne: "",
      umpire: "",
      teamTwo: "",
      open: false,
      isLoadingArray: [],
      selectedParkId: "",
      userName: localStorage.getItem("userName"),
      isDisabled: false,
      partName: "",
      parkField: "",
      exactStartTime: "10:00 AM",
      exactStartDate: "",
      startDate: "",
      game_type: "",
      startTime: "10:00 AM",
      note: "",
      startDateError: "",
      exactDateformat: "",
      timeError: "",
      parkNameOptions: [],
      fieldNameOptions: [],
      tournamentTeams: [],
      tournamentUmpire: [],
      teamLoader: true,
      isLoading: false,
      isLoadingField: false,
      isLoadingUmpire: true,
      tabsTo: 0,
      teamSelect: [],
      tournamentGameDetail: [],
      tournamentData: {},
      showLoader: 0,
      tournamentGuid: '',
      debounceTimer: null,
    };
  },
  validations() {
  const shouldValidateTeams = Number(this.game_type) === 1;

  return {
    name: { required },
    game_type: { required },
    startDate: { required },
    startTime: { required },
    partName: { required },
    teamOne: {
      required: shouldValidateTeams ? required : () => true
    },
    teamTwo: {
      required: shouldValidateTeams ? required : () => true
    }
  };
},
  props: {
    isEditingGame: {
      type: [Boolean, Number],
    },
    association_id: {
      type: [Number, String]
    },
    eventId: {
      type: [Number, String]
    },
    gameType: {
      type: [Number, String]
    },
    game_id: {
      type: [Number, String],
      default: null
    },
    field: {
      type: [Object, Number],
    },
    time: String,
    date: [String, Date],
    totalGames: Number,
    umpireId: [Number, String, null],
    team1Id: [Number, String, null],
    team2Id: [Number, String, null],
    selectedGameName: [ String, null]
  },
  computed: {
    shouldValidateTeams() {
      return Number(this.game_type) === 1;
    },
    remainingTeams: {
      get() {
        return this.tournamentTeams.filter(
          team => team.team.id !== this.teamOne);
      },
      set(value) {
        this.teamSelect = value;
      }
    },
  },
  watch: {


    isEditingGame(newVal) {
      console.log("isEditingGame changed to:", newVal);
    },
    partName(newVal) {
      if (newVal && !this.parkField && this.field) {
        this.populateFieldFromProps();
      }
    },
    umpireId(newVal) {
      this.umpire = newVal ?? "";
    },
    gameType: {
      handler(newVal) {
        this.game_type = newVal ?? 1;
      },
      immediate: true
    },
    field: {
      handler(newField) {
        if (newField && newField.park_id) {
          this.findAndSetPark(newField.park_id);
        }
        if (newField && newField.field_name) {
          this.populateFieldFromProps();
        }
      },
      immediate: true
    },

    time: {
      handler(newTime) {
        if (newTime) {
          this.startTime = newTime;
          this.exactStartTime = newTime;
          this.checkTime(); // Validate the time
        }
      },
      immediate: true
    },

    // Update the date watcher in the watch section:
    date: {
      handler(newDate) {
        if (newDate) {
          this.startDate = this.parseAndFormatDate(newDate);
          this.checkdate();
        }
      },
      immediate: true
    },
    totalGames: {
      handler(value) {
        if (this.selectedGameName) {
          this.name = this.selectedGameName;
        } else if (value !== undefined && (!this.name || this.name === "")) {
          this.name = `Game ${this.totalGames + 1}`;
        }

      },
      immediate: true // This ensures it runs on component creation
    },
  },
  methods: {
    setInitialGameData({ startDate, startTime, parkField }) {
    this.startDate = startDate;         // Format: "MMM DD, YYYY" (e.g., "Jun 17, 2025")
    this.startTime = startTime;         // Format: "hh:mm A" (e.g., "10:00 AM")
    this.parkField = parkField;         // Object from fieldNameOptions
  },
    debouncedGetGamePark(query) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.getGamePark(query);
        console.log("Fetching parks with query:", query);
      }, 600);
    },
    filterTeam() {
      this.remainingTeams = this.tournamentTeams.filter(
        team => team.team.id !== this.teamOne
      );
    },
    async getTournamentName() {
      this.showLoader = 1;
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}tournaments/getSingleTournament`,
          {tournament_guid: this.tournamentGuid}
        );

        if (response.data.statusCode === 200) {
            this.tournamentData = response.data.data;
            // this.initializeDate(this.tournamentData?.startDateForField);
            this.showLoader = 0;
        } else {
          this.errorMessage = response.data.message || "Unknown error occurred";
          this.showLoader = 0;
        }
      } catch (error) {
        this.errorMessage = "Failed to fetch data";
        this.showLoader = 0;
      } finally {
        this.showLoader = 0;
      }
  },
    dataReset() {
      this.$v.$reset();
      this.getTournamentName();
      if (this.tabsTo == 0) {
        // this.isDisabled = true;
        this.name = "";
        this.teamTwoId = "";
        this.teamOneId = "";
        this.teamOne = "";
        this.teamOne = "";
        this.umpire = "";
        this.game_type = "";
        this.teamTwo = "";
        this.partName = "";
        this.parkField = "";
        this.exactStartTime = "10:00 AM";
        this.exactStartDate = "";
        this.startDate = "";
        this.startTime = "10:00 AM";
        this.note = "";
        this.startDateError = "";
        this.exactDateformat = "";
        this.timeError = "";
        this.parkNameOptions = [];
        this.fieldNameOptions = [];
        this.getGamePark().then(() => {
      // Use nextTick to ensure DOM is updated
      this.$nextTick(() => {
        this.populateFromProps();
      });
    });
      } else {
        this.parkField = "";
      }
    },
    populateFromProps() {
      // Populate game name from totalGames prop
      if (!this.name) {
        if (this.selectedGameName) {
          this.name = this.selectedGameName;
        } else if (this.totalGames !== undefined) {
          this.name = `Game ${this.totalGames + 1}`;
        }
      }

      // Populate time
      if (this.time) {
        this.startTime = this.time;
        this.exactStartTime = this.time;
        this.checkTime();
      }
      if (this.gameType) {
        this.game_type = this.gameType;
      }

      // Populate date  
      if (this.date) {
        this.startDate = this.parseAndFormatDate(this.date);
        this.checkdate();
      }
      if (this.umpireId) {
        this.umpire = this.umpireId;
      }

      // Populate field (might need to wait for fieldNameOptions to load)
      if (this.field && this.field.field_name) {
        setTimeout(() => {
          this.populateFieldFromProps();
        }, 100);
      }

      if (this.team1Id && !this.teamOne) {
        this.teamOne = this.team1Id;
      }

      if (this.team2Id && !this.teamTwo) {
        this.teamTwo = this.team2Id;
      }
    },

    async findAndSetPark(parkId) {
      // First check if park exists in current options
      const existingPark = this.parkNameOptions.find(p => p.id == parkId);
      if (existingPark) {
        this.partName = existingPark;
        return;
      }

      // If not found, fetch parks using existing method
      // await this.getGamePark('');

      // Check again after fetching
      const parkAfterFetch = this.parkNameOptions.find(p => p.id == parkId);
      if (parkAfterFetch) {
        this.partName = parkAfterFetch;
      }
    },

populateFieldFromProps() {
  if (!this.field || !this.field.field_name) return;

  // Wait until fieldNameOptions are loaded
  const tryAssignField = () => {
    const matchingField = this.fieldNameOptions.find(
      option => option.field_name === this.field.field_name || option.id === this.field.id
    );

    if (matchingField) {
      this.parkField = matchingField;

      // ✅ Optionally auto-select partName from field if needed
      if (!this.partName && matchingField.park) {
        this.partName = matchingField.park;
      }
    } else if (this.partName && this.partName.id) {
      // Fetch new fields if park is selected but field not found
      this.getParkField('');

      // Retry after fetch delay
      setTimeout(() => {
        const fieldAfterFetch = this.fieldNameOptions.find(
          option => option.field_name === this.field.field_name || option.id === this.field.id
        );

        if (fieldAfterFetch) {
          this.parkField = fieldAfterFetch;
        } else {
          // Fallback: create a temp object
          this.parkField = {
            id: this.field.id || null,
            field_name: this.field.field_name
          };
        }
      }, 500);
    } else {
      // Fallback if no park and no matching field
      this.parkField = {
        id: this.field.id || null,
        field_name: this.field.field_name
      };
    }
  };

  // Retry if fieldNameOptions are not yet available
  if (!this.fieldNameOptions || !this.fieldNameOptions.length) {
    setTimeout(tryAssignField, 200);
  } else {
    tryAssignField();
  }
},
    initializeDate(start_date) {
      if (start_date) {
        this.startDate = this.parseAndFormatDate(start_date);
      }
      this.checkdate();
    },
    parseAndFormatDate(dateString) {
      if (!dateString) return "";

      // Handle YYYY-MM-DD format specifically
      if (typeof dateString === 'string' && dateString.match(/^\d{4}-\d{2}-\d{2}/)) {
        const parts = dateString.split("-");
        const year = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        const day = parseInt(parts[2], 10);
        const parsedDate = new Date(year, month, day);
        return this.formatDate(parsedDate);
      }

      // For other formats, try to parse normally
      const parsedDate = new Date(dateString);
      if (isNaN(parsedDate.getTime())) {
        return "Invalid Date";
      }

      return this.formatDate(parsedDate);
    },
    formatDate(date) {
      if (!(date instanceof Date) || isNaN(date.getTime())) return "Invalid Date";

      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const d = new Date(date);
      const month = monthNames[d.getMonth()];
      const day = String(d.getDate()).padStart(2, '0');
      const year = d.getFullYear();

      return `${month} ${day}, ${year}`;
    },

    checkdate: function () {
      const month = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "July",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      let startDateConvert;

      // Convert Start Date
      if (this.startDate && this.startDate.length === 12) {  // Format: "Mar 21, 2025"
        const startDateArray = this.startDate.split(" ");
        let startMonth = month.indexOf(startDateArray[0]) + 1; // Convert month to number
        startMonth = startMonth < 10 ? `0${startMonth}` : startMonth; // Add leading zero
        const startDay = startDateArray[1].replace(",", ""); // Remove comma
        const startYear = startDateArray[2];

        const formattedStartDate = `${startMonth}-${startDay}-${startYear}`;
        startDateConvert = new Date(formattedStartDate);
        this.exactStartDateformat = startDateConvert;
        this.exactStartDate = `${month[startMonth - 1]} ${startDay}, ${startYear}`;
      }

      this.checkTimeDate();
    },
    formatDateForDB(date) {
      if (!date) return null; // Ensure there's a valid date
      const d = new Date(date);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    },
    dispatchAction(actionName) {
      this.parkField = "";
      this.fieldNameOptions = [];
      switch (actionName.park_name) {
        case "Add Park":
          var tabs = 4;
          this.$root.$emit("AddParkInitiate", tabs);
          var elem = this.$refs.callPark;
          elem.click();
          break;
        default:
          // Assume that the actionName contains the selected park's ID
          this.selectedParkId = actionName.id;
          break;
      }
    },
    // errorNull: function () {
    //   if (
    //     this.name == "" ||
    //     this.exactStartDate == "" ||
    //     this.exactStartTime == "" ||
    //     this.game_type == "" ||
    //     // this.teamOne == "" ||
    //     // this.umpire == "" ||
    //     this.partName == ""
    //     // || this.teamTwo == ""
    //   ) {
    //     this.isDisabled = true;
    //   } else {
    //     this.isDisabled = false;
    //   }
    // },
    closeMain() {
      this.$root.$emit("AddPark");
      var elem = this.$refs.closeModalTournamentAddGame;
      elem.click();
    },
    newField() {
      this.$root.$emit("AddField");
      var elem = this.$refs.closeModalTournamentAddGame;
      elem.click();
    },
    getTournamentTeams() {
      this.teamLoader = true;
      // Create a FormData object
      const formData = new FormData();
      formData.append('tournament_guid', this.tournamentGuid);
      formData.append('association_id', this.association_id);

      axios
        .post(
          `${process.env.VUE_APP_API_URL}tournaments/teams/getTournamentTeamsForDropDown`,
          formData, {})
        .then((response) => {
          this.tournamentTeams = response.data.data;
          this.teamLoader = false;
        });
    },
    async getGamePark(query) {
      this.isLoading = true;
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}associationEvent/getEventPlayingFacility`, {
            params: {
              event_id: this.eventId,
              association_id: this.association_id,
              search: query || '' // send empty string if no query
            }
          }
        );

        if (response.data.statusCode === 200) {
          this.parkNameOptions = response.data.data.parkDetails;
                    this.findAndSetPark(this.field?.park_id || this.partName?.id || this.parkNameOptions[0]?.id);

        } else {
          this.errorMessage = response.data.message || "Unknown error occurred";
        }
      } catch (error) {
        this.errorMessage = "Failed to fetch data";
      } finally {
        this.isLoading = false;
      }
    },
    getParkField(searchQuery) {
      this.isLoadingField = true;
      axios
        .get(
          `${process.env.VUE_APP_API_URL}getParkField?park_id=${this.partName.id
          }&search=${searchQuery ? searchQuery : ""}`,
          this.details,
          {}
        )
        .then((response) => {
          this.fieldNameOptions = response.data.data.fields;
          this.isLoadingField = false;
        });
    },
    getTournamentUmpire() {
      this.isLoadingUmpire = true;
      axios
        .get(
          `${process.env.VUE_APP_API_URL}associationEvent/getUmpiresForDropDown?event_id=${this.eventId}&association_id=${this.association_id}`,
          {}
        )
        .then((response) => {
          this.tournamentUmpire = response.data.data.umpires;
          this.isLoadingUmpire = false;
        });
    },
    checkParkField: function () {
      this.getParkField();
      // this.errorNull();
    },
    dispatchfieldAction(actionName) {
      switch (actionName.field_name) {
        case "Add field":
          var tabs = 4;
          this.$root.$emit("AddFieldInitiate", {
            tabs,
            park_id: this.selectedParkId,
          });
          var elem = this.$refs.callField;
          elem.click();
          break;
      }
    },
    checkTime: function () {
      if (this.startTime != "") {
        var timeSplit = this.startTime.split(":"),
          hours,
          minutes;
        hours = timeSplit[0];
        minutes = timeSplit[1];
        if (hours > 12) {
          hours -= 12;
        } else if (hours < 12) {
          if (hours == 0) {
            hours = 12;
          }
        }
        this.exactStartTime = hours + ":" + minutes;
        this.timeError = "";
        this.isDisabledGame = false;
      }

      this.checkTimeDate();
    },
    closePark() {
      this.tabsTo = 0;
      var start_time = document.getElementById("startTime");
      if (start_time.value != "") {
        start_time.value = "";
      }
    },
    checkTimeDate() {
      this.startDateError = this.exactStartDate != "" ? "" : "on";
      if (this.exactStartTime != "" && this.exactStartDate != "") {
        this.exactDateformat = this.exactStartDate + " " + this.exactStartTime;
      }
      // this.errorNull();
    },
    async saveGame(index) {
      if (this.game_id) {
        // UPDATE existing game
        const gameToUpdate = {
          db_id: this.game_id,
          teamA: this.teamOne,
          teamB: this.teamTwo,
          assignedDate: this.formatDateForDB(this.startDate),
          assignedTime: this.startTime,
          assignedFieldId: this.parkField?.id || "",
          unlink: false
        };
        await this.updateGame(gameToUpdate);
      }
       else {
        // ADD new game
        await this.addGame(index);
      }
    },

    async addGame(index) {
      this.$v.$touch();
      if (this.$v.$pending || this.$v.$error || this.$v.$invalid) return;

      this.showLoaderGame = true;
      this.isDisabledGame = true;
      this.$set(this.isLoadingArray, index, true);

      const formData = new FormData();
      formData.append("game_name", this.name || "");
      formData.append("team_1_id", this.teamOne);
      formData.append("team_2_id", this.teamTwo);
      formData.append("event_id", this.eventId);
      formData.append("start_date", this.formatDateForDB(this.startDate));
      formData.append("start_time", this.startTime);
      formData.append("park_id", this.partName.id);
      formData.append("game_type", this.game_type);
      formData.append("comments", this.note || "");
      formData.append("association_id", this.association_id);
      if (this.parkField) {
        formData.append("field_id", this.parkField.id || "");
      }
      formData.append("tournament_id", this.tournamentData.id);
      formData.append("umpire_id", this.umpire === 0 || this.umpire === undefined ? "" : this.umpire);

      try {
        await axios.post(
          `${process.env.VUE_APP_API_URL}tournaments/storeTournamentGames`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        this.$root.$emit("RefreshTournamentGames");
        this.$emit("RefreshPoolPlayGames");

        this.tabsTo = 0;
        this.showLoaderGame = false;
        this.isDisabledGame = false;
        this.$set(this.isLoadingArray, index, false);

        this.$refs.closeModalTournamentAddGame.click();
      } catch (error) {
        console.error("Error adding game:", error);
        this.showLoaderGame = false;
        this.isDisabledGame = false;
        this.$set(this.isLoadingArray, index, false);
      }
    },

    async updateGame(game) {
      this.showLoaderGame = true;
      this.isDisabledGame = true;

      const formData = new FormData();
      formData.append("game_name", this.name || "");
      if (this.teamOne) {
        formData.append("team_1_id", this.teamOne);
      }
      if (this.teamTwo) {
        formData.append("team_2_id", this.teamTwo);
      }
      formData.append("game_type", this.game_type);
      formData.append("event_id", this.eventId);
      formData.append("tournament_id", this.tournamentData.id);
      formData.append("umpire_id", this.umpire === 0 || this.umpire === undefined ? "" : this.umpire);

      if (game.unlink) {
        formData.append("start_date", "");
        formData.append("start_time", "");
        formData.append("field_id", "");
      } else {
        formData.append("start_date", this.formatDateForDB(this.startDate));
        formData.append("start_time", this.startTime);
        if (this.parkField) {
          formData.append("field_id", this.parkField.id || "");
        }
      }

      if (!game?.db_id) {
        console.error("No game ID found to update!");
        this.showLoaderGame = false;
        this.isDisabledGame = false;
        return;
      }

      formData.append("game_id", game.db_id);

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}tournaments/editTournamentGame`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        console.log("Game updated successfully", response.data);
        this.$root.$emit("RefreshTournamentGames");
        this.$emit("RefreshPoolPlayGames");
        this.$refs.closeModalTournamentAddGame.click();
      } catch (error) {
        console.error("Error updating game", error);
      } finally {
        this.showLoaderGame = false;
        this.isDisabledGame = false;
      }
    },
  },

  mounted() {
    this.$root.$on("openTournamentAddGameModal", (tournament) => {
      this.tournamentGuid = tournament;
      var elem = this.$refs.openModalTournamentAddGame;
      if (elem) {
        elem.click();
      }
      this.getTournamentTeams();
      this.getTournamentUmpire();

      // Populate from props when modal opens
    this.$nextTick(() => {
      setTimeout(() => {
        this.populateFromProps();
      }, 50);
    });
    });

    this.$root.$on("addedPark", (Tabs) => {
      this.tabsTo = Tabs;
      this.getGamePark();
      var elem = this.$refs.openModalTournamentAddGame;
      elem.click();
    });
    this.$root.$on("addTournamentGameField", (Tabs) => {
      this.tabsTo = Tabs;
      this.parkField = "";
      this.getParkField();
      var elem = this.$refs.openModalTournamentAddGame;
      elem.click();
    });
    this.$root.$on("checkMain", () => {
      this.closeMain();
    });
  },
};
</script>
